import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_CONFIRMATION_MODAL_OPEN_FOR_LOCK, SET_INPUT_CHANGES_FOR_LOCK } from 'store/actions';
import CloseConfirmationLock from './ConfirmationLock';
/**Wrapper Component for Locking (Reserve the component for certain time while this another user cannot view it.)
 * Takes children as props
 * locked time hold time to locked that component
 * updateLockedTime to update or remove the locked time
 * onFinishLock to after locked time expires tell whats to do
 * item current selected item.
 */
const LockWrapper = ({ children, lockedTime, updateLockedTime, item, onFinishLock }) => {
    const { isOpenConfirmationModalLock, isInputChangesForLock } = useSelector((state) => state.customization); //input changes for lock not needed as per new flow
    const [inputChanges, setInputChanges] = useState(false);
    const dispatch = useDispatch();
    const expiryConfirmationModal = parseInt(process.env.REACT_APP_LOCK_CONFIRMATION_MODAL); //Buffer time for confirmation modal open
    const isInputChangesForLockRef = useRef(isInputChangesForLock); //Not needed
    const isInputChangesRef = useRef(inputChanges);
    const itemRef = useRef(item);
    let timeOut;
    useEffect(() => {
        isInputChangesForLockRef.current = isInputChangesForLock; // Update the ref when selectedValue changes
    }, [isInputChangesForLock]);

    useEffect(() => {
        isInputChangesRef.current = inputChanges;
    }, [inputChanges]);
    useEffect(() => {
        //ref for item since interval it will not have item and but when we add to ref it will get item from ref because if reference to the browser memory address which will have item data.
        itemRef.current = item;
    }, [item]);

    const checkInputChange = () => {
        const currentTime = new Date();
        /**
         * If there is any input change the update lock time and set input changes false
         * else Currrent time is greater than locked time clear all thing up and redirect to the listing page
         * else if current time is lesser than  locked time and no input change means user is inactive show confirmation modal to continue editing or exit.
         */
        if (isInputChangesRef.current) {
            if (itemRef.current) updateLockedTime(itemRef.current, 'add');
            // dispatch({ type: SET_INPUT_CHANGES_FOR_LOCK, isInputChangesForLock: false });
            setInputChanges(false);
            isInputChangesRef.current = false;
        } else if (Date.parse(currentTime) > Date.parse(lockedTime)) {
            dispatch({ type: SET_CONFIRMATION_MODAL_OPEN_FOR_LOCK, isOpenConfirmationModalLock: false });
            //dispatch({ type: SET_INPUT_CHANGES_FOR_LOCK, isInputChangesForLock: false });
            setInputChanges(false);
            isInputChangesRef.current = false;
            onFinishLock();
        } else {
            dispatch({ type: SET_CONFIRMATION_MODAL_OPEN_FOR_LOCK, isOpenConfirmationModalLock: true });
        }
    };

    //Interval function to check input change or time passed or show confirmation modal

    useEffect(() => {
        timeOut = setInterval(checkInputChange, expiryConfirmationModal);

        return () => {
            /**
             * On onmounting component clear the listener, values and interval timer
             */

            clearInterval(timeOut);
        };
    }, [lockedTime]); //if locked time change this useEffect function will call

    useEffect(() => {
        //dispatch({ type: SET_INPUT_CHANGES_FOR_LOCK, isInputChangesForLock: false });
        dispatch({ type: SET_CONFIRMATION_MODAL_OPEN_FOR_LOCK, isOpenConfirmationModalLock: false });
        //isInputChangesForLockRef.current = false;
        isInputChangesRef.current = false;
        //on browser close
        //Event Tracker you can add more if needed.
        function activity() {
            setInputChanges(true);
        }
        var activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll'];
        activityEvents.forEach(function (eventName) {
            document.addEventListener(eventName, activity, true);
        });
        const handleBeforeUnload = (event) => {
            updateLockedTime(item, 'remove');
            if (timeOut) {
                clearInterval(timeOut);
            }
            window.removeEventListener('beforeunload', handleBeforeUnload);
            // window.confirm('Are you sure?');
            // event.preventDefault(); // Cancel the default behavior
            // event.returnValue = 'Are you sure you want to leave this page huh babuchak?'; // Chrome requires this to be set
            // const confirmationMessage = 'Are you sure you want to leave this page huh babuchak?';
            // if (window.confirm(confirmationMessage)) {
            //     updateLockedTime(item, 'remove');
            //     // If the user confirms, allow the tab to be closed
            //     window.removeEventListener('beforeunload', handleBeforeUnload);
            // }
        };

        //Event listener for tab or browser close
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            /**on unmounting component release the time lock  */
            window.removeEventListener('beforeunload', handleBeforeUnload);
            activityEvents.forEach(function (eventName) {
                document.removeEventListener(eventName, activity, true);
            });
            if (timeOut) {
                clearInterval(timeOut);
            }

            if (item) updateLockedTime(item, 'remove');
        };
    }, []);

    /**Confirmation Modal if type Y then update locked time means if enable editing the update the locked time
     * else if type Y then remove the lock time and return back to listing and clear current question data value
     * finally clear all the values to default
     */
    const onCloseModalHandler = async (type) => {
        if (type === 'Y') {
            await updateLockedTime(item, 'add');
            dispatch({ type: SET_CONFIRMATION_MODAL_OPEN_FOR_LOCK, isOpenConfirmationModalLock: false });
            // dispatch({ type: SET_INPUT_CHANGES_FOR_LOCK, isInputChangesForLock: false });
            setInputChanges(false);
            // isInputChangesForLockRef.current = false;
            isInputChangesRef.current = false;
        } else {
            if (item) updateLockedTime(item, 'remove');
            onFinishLock();
        }
    };
    return (
        <>
            {children}
            {isOpenConfirmationModalLock && <CloseConfirmationLock parentModalClose={onCloseModalHandler} />}
        </>
    );
};
export default LockWrapper;
